import { ImageContentGridBottom } from "../../../../modules/content/components/ImageContentGridBottom/ImageContentGridBottom";
import { ImageContentGridTop } from "../../../../modules/content/components/ImageContentGridTop/ImageContentGridTop";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { IImageContentGridBlockProps } from "./ImageContentGridBlock.props";

export const ImageContentGridBlock = (props: IImageContentGridBlockProps) => {
  const {
    alignment,
    anchorId,
    buttons,
    description,
    eyebrow,
    heading,
    items,
    parentClass,
    spacing,
    variant,
  } = props;
  if (!items?.length) return null;
  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-16 md:gap-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {variant === "image-bottom" ? (
          <ImageContentGridBottom {...props} />
        ) : (
          <ImageContentGridTop {...props} />
        )}
      </div>
    </VelvetSection>
  );
};

ImageContentGridBlock.displayName = "Block::ImageContentGridBlock";
